export default __webpack_public_path__ + "static/media/emptyFolder.0d9851c0.png";